import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const IntegrationCardSkeleton: React.FC = () => {
  return (
    <Card className="shadow-none">
      <CardHeader className="pb-3 px-4 pt-4">
        <div className="flex items-start justify-between">
          <div className="flex items-center space-x-2.5 flex-1">
            {/* Icon skeleton */}
            <Skeleton className="h-9 w-9 rounded-lg" />
            <div className="flex-1 min-w-0 space-y-1.5">
              {/* Title skeleton */}
              <Skeleton className="h-4 w-24" />
              {/* Description skeleton */}
              <Skeleton className="h-3 w-32" />
            </div>
          </div>
          <div className="flex items-center space-x-1.5 ml-3">
            {/* Status icon skeleton */}
            <Skeleton className="h-4 w-4 rounded-full" />
            {/* Status text skeleton */}
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0 px-4 pb-4">
        {/* Button skeleton */}
        <div className="flex items-center justify-end">
          <Skeleton className="h-8 w-24" />
        </div>
      </CardContent>
    </Card>
  );
};
